import { HttpErrorResponse } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of, catchError, map, switchMap } from 'rxjs';
import { finalizeLoader } from '@app/shared/components';
import { reflectionsActions } from '../actions/reflections.actions';
import { HttpService } from '../services/http.service';

@Injectable()
export class ReflectionsEffects {
    private readonly actions = inject(Actions);
    private readonly httpService = inject(HttpService);

    getReflections$ = createEffect(() => {
        return this.actions.pipe(
            ofType(reflectionsActions.getReflections),
            switchMap(({ value }) => {
                return this.httpService.getReflections(value).pipe(
                    finalizeLoader('reflections-list'),
                    map(({ payload, total }) => reflectionsActions.getReflectionsSuccess({ payload, total })),
                    catchError((response: HttpErrorResponse) => of(reflectionsActions.getReflectionsError({ code: response.status }))),
                );
            }),
        );
    });
}
